import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [!_vm.loading ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.favInfo'),
      "prepend-icon": _vm.icon,
      "data-cy": "btn_toggle_favorite"
    },
    on: {
      "click": _vm.process
    }
  }) : _vm._e(), _vm.loading ? _c(VProgressCircular, {
    attrs: {
      "data-cy": "loading_favorite",
      "color": _vm.color,
      "size": "33",
      "width": "2",
      "indeterminate": ""
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };